module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#comment",
      toString: function () {
        return this.url;
      }
    }